import { useEffect, useState } from "react";
import api from "../lib/api";

export default function SalesScopeSelector({ value, onChange, testId = "agent-scope-select" }) {
  const [scopes, setScopes] = useState([]);
  useEffect(() => { api.get("/sales-scopes").then((response) => setScopes(response.data)); }, []);
  if (scopes.length <= 1) return null;
  return <div className="sales-scope-picker"><label htmlFor={testId}>Agent Name</label><select id={testId} data-testid={testId} value={value} onChange={(event) => onChange(event.target.value)}><option value="">All permitted agents</option>{scopes.map((scope) => <option key={scope.id} value={scope.id}>{scope.is_self ? "My sales" : `${scope.name} · downline`}</option>)}</select></div>;
}